/**
 * Returns true if given element has at least 1 text node child with non-empty content
 */
export const hasTextChild = (element: Element): boolean => {
  for (let i = 0; i < element.childNodes.length; ++i) {
    const child = element.childNodes[i];
    if (child instanceof Text && child.textContent?.trim() !== '') {
      return true;
    }
  }

  return false;
};
